module.exports = __webpack_public_path__ + "img/icon-home.63838c25.svg";